import { CloseOutlined } from '@ant-design/icons';
import { Input, Modal, Tree } from 'antd'
import React, { useEffect, useState } from 'react'
import { TreeNode } from '../../../../Customers/CustomerGroup/Component/SideBar';
import useToast from '../../../../../hook/useToast';
import { useNavigate } from 'react-router-dom';
import useLoading from '../../../../../hook/useLoading';
import useDebounce from '../../../../../hook/useDebounce';
import { getListGroup } from "../../../../../api/groupCustomerV2/groupCustomerV2Api";
import { convertGroupsToTreeNode } from '../../../../Customers/CustomerGroup/indexV2';
import '../../CampaignSendsNotifications.scss'
import { InfoCampaignTmp } from '..';
import { IGroupCampaign } from '../../../../../api/campaign/campaignApi';
import { useSelector } from 'react-redux';
import { selectorCategoryCarIds } from '../../../../../store/slices/categoryCarSlice';

interface Props {
    open?: boolean;
    infoCampaign?: InfoCampaignTmp

    groupCustomerSelected: IGroupCampaign[]

    setInfoCampaign?: (value?: InfoCampaignTmp) => void
    setGroupCustomerSelected: (value: IGroupCampaign[]) => void
    onClose?: () => void;
}

const ModalGroupCus: React.FC<Props> = ({
    open,
    infoCampaign,

    groupCustomerSelected,
    setInfoCampaign,
    setGroupCustomerSelected,
    onClose
}) => {


    const pushToast = useToast();
    const pushLoading = useLoading()
    const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

    const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
    const [autoExpandParent, setAutoExpandParent] = useState(true);


    const [searchGroup, setSearchGroup] = useState<string>()

    const [groupCustomerSelectedTmp, setGroupCustomerSelectedTmp] = useState<IGroupCampaign[]>([])

    const [listGroup, setListGroup] = useState<TreeNode[]>([])

    const gListGroup = useDebounce(async () => {
        pushLoading(true)
        const result = await getListGroup(
            permittedCategoryCarIds,
            undefined, undefined, undefined, undefined, searchGroup
        )
        if (result.status) {
            setListGroup(convertGroupsToTreeNode(result.data))
        } else {
            pushToast(result.message, "warning")
            setListGroup([])
        }
        pushLoading(false)
    }, 1000)

    const onExpand = (newExpandedKeys: React.Key[]) => {
        setExpandedKeys(newExpandedKeys);
        setAutoExpandParent(false);
    };

    const handleSelect = (selectedKeys: React.Key[], info: any) => {
        const clickedItem = info.node;

        const itemNode: IGroupCampaign = {
            id: clickedItem.key,
            total: clickedItem.customerCount,
            title: clickedItem.title,
        };
        // setGroupCustomerSelectedTmp(prev => {
        //     const exists = prev.some(item => item.id === itemNode.id);

        //     if (exists) {
        //         // đã có → xoá
        //         return prev.filter(item => item.id !== itemNode.id);
        //     }

        //     // chưa có → thêm
        //     return [...prev, itemNode];
        // });

         setGroupCustomerSelectedTmp(prev => {
        const exists = prev.some(
            item => Number(item.id) === Number(itemNode.id)
        );

        if (exists) {
            return prev.filter(
                item => Number(item.id) !== Number(itemNode.id)
            );
        }

        return [...prev, itemNode];
    });

    };

    const handleConfirm = () => {
        setGroupCustomerSelected?.(groupCustomerSelectedTmp)
        onClose?.()
    };
    useEffect(() => {
        if (open) {
            gListGroup()
        }
    }, [searchGroup])

    useEffect(() => {
        if (open) {
            if (!listGroup.length)
                gListGroup()
            setGroupCustomerSelectedTmp(groupCustomerSelected || [])

        } else {
            setSearchGroup(undefined)
            setGroupCustomerSelectedTmp([])
        }
    }, [open, searchGroup])



    // useEffect(() => {
    //   console.log(groupCustomerSelected,groupCustomerSelectedTmp);


    // }, [groupCustomerSelectedTmp])
    return (
        <Modal
            open={open}
            title={
                <div className="custom-page-css bg-FCFCFD d-flex justify-betweeen align-center  w-full border-b-F0F0F0 rounded overflow-hidden">
                    <span className="text-base text-344054 fw-500 font-medium">Chọn nhóm khách hàng</span>
                    <CloseOutlined className="text-base text-8B8B8B" onClick={onClose} />
                </div>
            }


            centered
            className="w-modal modal-content-update-group ant-modal-size custom-modal-scroll"
            closeIcon={false}
            footer={(<>

                <div className='custom-page-css w-full border-t-00000011'
                >
                    <button
                        className='custom-page-css py-2 px-3 rounded mt-2 bg-1890FF border-1890FF text-white text-sm font-regular'
                        onClick={handleConfirm}
                    >Xác nhận</button>
                </div>
            </>)}
            onCancel={onClose}
        >
            <div className=" py-2"
            >
                <Input
                    style={{ marginBottom: 8 }}
                    placeholder="Tìm nhóm"
                    value={searchGroup}
                    onChange={(e) => setSearchGroup(e.target.value)}
                />
                <Tree
                    multiple
                    expandedKeys={expandedKeys}
                    autoExpandParent={autoExpandParent}
                    treeData={listGroup}
                    selectedKeys={groupCustomerSelectedTmp.map(item => item.id.toString())}
                    onSelect={handleSelect}
                    onExpand={onExpand}
                />
            </div>
        </Modal>
    )
}

export default ModalGroupCus
